import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { Composition } from '../../models/yarn/composition';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class CompositionProxyService {
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/composition';

  private readonly httpClient = inject(HttpClient);

  /**
   * Get all available compositions
   * @returns Observable of Composition array
   */
  public getAllCompositions(): Observable<ApiResponse<Composition[]>> {
    return this.httpClient.get<ApiResponse<Composition[]>>(`${this.baseUrl}/all`);
  }
}
